export const CREATE_CASHFLOW = 'CREATE_CASHFLOW';
export const GET_CASHFLOWS = 'GET_CASHFLOWS';
export const GET_CASHFLOW_TAGS = 'GET_CASHFLOW_TAGS';
export const GET_CASHFLOW = 'GET_CASHFLOW';
export const DELETE_CASHFLOW = 'DELETE_CASHFLOW';
export const UPDATE_CASHFLOW = 'UPDATE_CASHFLOW';
